import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { toast } from 'react-hot-toast';
import { FaUserCircle } from 'react-icons/fa';
import { useAuth } from '../../authentication/AuthContext';

const ProfileDropdown = ({ username = "User", menuItems = [], profilePic }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { refresh: refreshAuth } = useAuth();

  const handleToggle = (nextShow) => {
    setDropdownOpen(nextShow);
  };

  const Logoutfunction = () => {
    localStorage.clear();
    refreshAuth(); // resets AuthContext to "anon"
    toast.success('Logout Successful!');
  };

  return (
    <Dropdown show={dropdownOpen} onToggle={handleToggle} className="profile-dropdown-wrapper">
      <Dropdown.Toggle
        id="dropdown-profile"
        as="a"
        className={classNames('nav-link', 'nav-user', 'me-0', 'cursor-pointer', { show: dropdownOpen })}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <span
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #153f66, #1a5276)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          }}
        >
          <FaUserCircle color="#fff" size={20} />
        </span>

        <span className="pro-user-name ms-2" style={{ fontWeight: 500, color: '#153f66' }}>
          {username} <FeatherIcon icon="chevron-down" size={14} />
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="dropdown-menu-end profile-dropdown shadow-lg"
        style={{
          borderRadius: '12px',
          padding: '8px 0',
          minWidth: '180px',
        }}
      >
        <div onClick={() => setDropdownOpen(false)}>
          {menuItems.map((item, i) => (
            <Link
              key={i}
              to={item.redirectTo}
              onClick={item.label === 'Logout' ? Logoutfunction : undefined}
              className="dropdown-item notify-item d-flex align-items-center"
              style={{
                padding: '10px 15px',
                fontSize: '14px',
                transition: 'background 0.2s',
              }}
            >
              <FeatherIcon icon={item.icon} className="me-2" size={16} />
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
